import { v4 as uuid } from "uuid";
import { formatDate } from "../utils/authUtils";
/**
 * User Database can be added here.
 * You can add default users of your wish with different attributes
 * */

export const users = [
  {
    _id: uuid(),
    firstName: "Naman",
    lastName: "Jain",
    username: "namanjain_321",
    password: "naman!123",
    pic: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQt-F5GQg8qB2fWquF1ltQvAT2Z8Dv5pJLb9w&usqp=CAU",
    bio: "Aspiring Software Developer",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },

  {
    _id: uuid(),
    firstName: "Shubham",
    lastName: "Jain",
    username: "shubham@gmail.com",
    password: "shubham123",
    createdAt: "2022-01-25T10:38:12+05:30",
    updatedAt: "2022-05-14T18:08:40+05:30",
    userHandler: "shubham",
    pic: "https://thumbs.dreamstime.com/b/nice-to-talk-smart…ucasian-guy-smiling-broadly-nice-to-112345489.jpg",
    link: "https://shubhamjain.netlify.app",
    bio: "Aspiring Software Developer",
    followers: [],
    following: [
      {
        _id: uuid(),
        firstName: "Devika",
        lastName: "Ghosh",
        username: "devikaghosh@gmail.com",
        password: "1234abcd",
        createdAt: "2022-03-21T10:12:12+05:30",
        updatedAt: "2022-05-14T18:07:41+05:30",
        userHandler: "devika",
        pic: "https://res.cloudinary.com/donqbxlnc/image/upload/v1652423672/images_oxp7vm.jpg",
        link: "https://devika.netlify.app",
        bio: "Social Media Influencer",
        followers: [],
        following: [],
        bookmarks: [],
        id: "2",
      },
      {
        _id: uuid(),
        firstName: "Varun",
        lastName: "Pruthi",
        username: "varunpruthi@gmail.com",
        password: "1234asdf",
        createdAt: "2022-04-09T09:30:12+05:30",
        updatedAt: "2022-05-14T18:07:41+05:30",
        userHandler: "varunpruthi",
        pic: "https://thumbs.dreamstime.com/b/nice-to-talk-smart…ucasian-guy-smiling-broadly-nice-to-112345489.jpg",
        link: "https://pruthivarun.netlify.app",
        bio: "Web Developer",
        followers: [],
        following: [],
        bookmarks: [],
        id: "4",
      },
    ],
    bookmarks: [],
    id: "1",
  },
  {
    _id: "asassddsd243434",
    firstName: "Devika",
    lastName: "Ghosh",
    username: "devikaghosh@gmail.com",
    password: "1234abcd",
    createdAt: "2022-03-21T10:12:12+05:30",
    updatedAt: "2022-05-14T18:10:33+05:30",
    userHandler: "devika",
    pic: "https://res.cloudinary.com/donqbxlnc/image/upload/v1652423672/images_oxp7vm.jpg",
    link: "https://devika.netlify.app",
    bio: "Social Media Influencer",
    followers: [],
    following: [
      {
        _id: "asassdafdgdk",
        firstName: "Kartik",
        lastName: "Rao",
        username: "raokartik@gmail.com",
        password: "1234abcd",
        createdAt: "2022-01-25T10:38:12+05:30",
        updatedAt: "2022-05-14T18:08:40+05:30",
        userHandler: "kartik",
        pic: "https://thumbs.dreamstime.com/b/nice-to-talk-smart…ucasian-guy-smiling-broadly-nice-to-112345489.jpg",
        link: "https://vineetspage.netlify.app",
        bio: "SDE-1 at Google",
        followers: [],
        following: [],
        bookmarks: [],
        id: "1",
      },
      {
        _id: uuid(),
        firstName: "Varun",
        lastName: "Pruthi",
        username: "varunpruthi@gmail.com",
        password: "1234asdf",
        createdAt: "2022-04-09T09:30:12+05:30",
        updatedAt: "2022-05-14T18:07:41+05:30",
        userHandler: "varunpruthi",
        pic: "https://thumbs.dreamstime.com/b/nice-to-talk-smart…ucasian-guy-smiling-broadly-nice-to-112345489.jpg",
        link: "https://pruthivarun.netlify.app",
        bio: "Web Developer",
        followers: [],
        following: [],
        bookmarks: [],
        id: "4",
      },
      {
        _id: "asassddfd23dgdg334df",
        firstName: "Shilpa",
        lastName: "Shetty",
        username: "shilpashetty@gmail.com",
        password: "1234asdf09",
        createdAt: "2022-03-19T09:30:12+05:30",
        updatedAt: "2022-05-14T18:10:06+05:30",
        userHandler: "shilpashetty",
        pic: "https://res.cloudinary.com/donqbxlnc/image/upload/v1652423672/images_oxp7vm.jpg",
        link: "https://shilpashetty.netlify.app",
        bio: "SDE-1 at Invact",
        followers: [],
        following: [],
        bookmarks: [],
        id: "7",
      },
      {
        _id: "asassddfd232fg23ssfdf",
        firstName: "Shanu",
        lastName: "Agarwal",
        username: "shanuagarwal@gmail.com",
        password: "1234asdf",
        createdAt: "2022-02-10T09:30:12+05:30",
        updatedAt: "2022-05-14T18:10:06+05:30",
        userHandler: "shanuagarwal",
        pic: "https://thumbs.dreamstime.com/b/nice-to-talk-smart…ucasian-guy-smiling-broadly-nice-to-112345489.jpg",
        link: "https://shanuagarwal.netlify.app",
        bio: "SDE at Evive",
        followers: [],
        following: [],
        bookmarks: [],
        id: "5",
      },
    ],
    bookmarks: [],
    id: "2",
  },
  {
    _id: "asassddfdsfdgsd32323",
    firstName: "Deepansh",
    lastName: "Bhargava",
    username: "deepanshbhargava@gmail.com",
    password: "1234asdf",
    createdAt: "2022-05-12T08:30:12+05:30",
    updatedAt: "2022-05-14T18:11:48+05:30",
    userHandler: "deepanshbhargava",
    pic: "https://thumbs.dreamstime.com/b/nice-to-talk-smart…ucasian-guy-smiling-broadly-nice-to-112345489.jpg",
    link: "https://deepanshbhargava.netlify.app",
    bio: "Full Stack Developer",
    followers: [],
    following: [
      {
        _id: uuid(),
        firstName: "Devika",
        lastName: "Ghosh",
        username: "devikaghosh@gmail.com",
        password: "1234abcd",
        createdAt: "2022-03-21T10:12:12+05:30",
        updatedAt: "2022-05-14T18:07:41+05:30",
        userHandler: "devika",
        pic: "https://res.cloudinary.com/donqbxlnc/image/upload/v1652423672/images_oxp7vm.jpg",
        link: "https://devika.netlify.app",
        bio: "Social Media Influencer",
        followers: [],
        following: [],
        bookmarks: [],
        id: "2",
      },
    ],
    bookmarks: [],
    id: "3",
  },
  {
    _id: "asassddfd232fgfg323",
    firstName: "Varun",
    lastName: "Pruthi",
    username: "varunpruthi@gmail.com",
    password: "1234asdf",
    createdAt: "2022-04-09T09:30:12+05:30",
    updatedAt: "2022-05-14T18:12:29+05:30",
    userHandler: "varunpruthi",
    pic: "https://thumbs.dreamstime.com/b/nice-to-talk-smart…ucasian-guy-smiling-broadly-nice-to-112345489.jpg",
    link: "https://varunpruthi.netlify.app",
    bio: "Web Developer",
    followers: [],
    following: [
      {
        _id: "asassddfd232fg23ssfdf",
        firstName: "Shanu",
        lastName: "Agarwal",
        username: "shanuagarwal@gmail.com",
        password: "1234asdf",
        createdAt: "2022-02-10T09:30:12+05:30",
        updatedAt: "2022-05-14T18:10:06+05:30",
        userHandler: "shanuagarwal",
        pic: "https://thumbs.dreamstime.com/b/nice-to-talk-smart…ucasian-guy-smiling-broadly-nice-to-112345489.jpg",
        link: "https://shanuagarwal.netlify.app",
        bio: "SDE at Evive",
        followers: [],
        following: [],
        bookmarks: [],
        id: "5",
      },
      {
        _id: "asassddfd23dgdg334df",
        firstName: "Shilpa",
        lastName: "Shetty",
        username: "shilpashetty@gmail.com",
        password: "1234asdf09",
        createdAt: "2022-03-19T09:30:12+05:30",
        updatedAt: "2022-05-14T18:10:06+05:30",
        userHandler: "shilpashetty",
        pic: "https://res.cloudinary.com/donqbxlnc/image/upload/v1652423672/images_oxp7vm.jpg",
        link: "https://shilpashetty.netlify.app",
        bio: "SDE-1 at Invact",
        followers: [],
        following: [],
        bookmarks: [],
        id: "7",
      },
      {
        _id: "fdgdg5590sd90",
        firstName: "Aashita",
        lastName: "Jha",
        username: "aashitajha@gmail.com",
        password: "1234asdf",
        createdAt: "2022-03-20T09:30:12+05:30",
        updatedAt: "2022-05-14T18:12:08+05:30",
        userHandler: "aashitajha",
        pic: "https://res.cloudinary.com/donqbxlnc/image/upload/v1652423672/images_oxp7vm.jpg",
        link: "https://aashitajha.netlify.app",
        bio: "SDE-II at Invact",
        followers: [],
        following: [],
        bookmarks: [],
        id: "8",
      },
    ],
    bookmarks: [],
    id: "4",
  },
  {
    _id: "asassddfd232fg23ssfdf",
    firstName: "Shanu",
    lastName: "Agarwal",
    username: "shanuagarwal@gmail.com",
    password: "1234asdf",
    createdAt: "2022-02-10T09:30:12+05:30",
    updatedAt: formatDate(),
    userHandler: "shanuagarwal",
    pic: "https://thumbs.dreamstime.com/b/nice-to-talk-smart…ucasian-guy-smiling-broadly-nice-to-112345489.jpg",
    link: "https://shanuagarwal.netlify.app",
    bio: "SDE at Evive",
    followers: [],
    following: [],
    bookmarks: [],
  },
  {
    _id: "asassddfasadsdgfssfdf",
    firstName: "Vineet",
    lastName: "Singhal",
    username: "vineetsinghal@gmail.com",
    password: "1234asdf09",
    createdAt: "2022-02-17T09:30:12+05:30",
    updatedAt: formatDate(),
    userHandler: "vineetsinghal",
    pic: "https://thumbs.dreamstime.com/b/nice-to-talk-smart…ucasian-guy-smiling-broadly-nice-to-112345489.jpg",
    link: "https://karthikbandi.netlify.app",
    bio: "SDE-1 at College Duniya",
    followers: [],
    following: [],
    bookmarks: [],
  },
  {
    _id: "asassddfd23dgdg334df",
    firstName: "Shilpa",
    lastName: "Shetty",
    username: "shilpashetty@gmail.com",
    password: "1234asdf09",
    createdAt: "2022-03-19T09:30:12+05:30",
    updatedAt: formatDate(),
    userHandler: "shilpashetty",
    pic: "https://res.cloudinary.com/donqbxlnc/image/upload/v1652423672/images_oxp7vm.jpg",
    link: "https://shilpashetty.netlify.app",
    bio: "SDE-1 at Invact",
    followers: [],
    following: [],
    bookmarks: [],
  },
  {
    _id: "fdgdg5590sd90",
    firstName: "Aashita",
    lastName: "Jha",
    username: "aashitajha@gmail.com",
    password: "1234asdf",
    createdAt: "2022-03-20T09:30:12+05:30",
    updatedAt: formatDate(),
    userHandler: "aashitajha",
    pic: "https://res.cloudinary.com/donqbxlnc/image/upload/v1652423672/images_oxp7vm.jpg",
    link: "https://aashitajha.netlify.app",
    bio: "SDE-II at Invact",
    followers: [],
    following: [],
    bookmarks: [],
  },
];
